"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ExpandOutline = _interopRequireDefault(require("@rsuite/icon-font/lib/action/ExpandOutline"));

// Generated by script, don't edit it please.
var ExpandOutline = (0, _createSvgIcon["default"])({
  as: _ExpandOutline["default"],
  ariaLabel: 'expand outline',
  category: 'action',
  displayName: 'ExpandOutline'
});
var _default = ExpandOutline;
exports["default"] = _default;
module.exports = exports.default;